'use client';

import { useState, KeyboardEvent, useEffect, useRef } from 'react';
import UpArrow from '@src/assets/svg/upArrow';
import { useChat } from '../context/ChatContext';

export default function ChatInput() {
  const { sendMessage, isStreaming } = useChat();
  const [input, setInput] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const textareaRef = useRef<HTMLTextAreaElement>(null);

  useEffect(() => {
    const textarea = textareaRef.current;
    if (!textarea) return;

    textarea.style.height = 'auto';

    const lineHeight = parseFloat(
      window.getComputedStyle(textarea).lineHeight || '20'
    );
    const maxHeight = lineHeight * 4;
    const nextHeight = Math.min(textarea.scrollHeight, maxHeight);

    textarea.style.height = `${nextHeight}px`;
    textarea.style.overflowY =
      textarea.scrollHeight > maxHeight ? 'auto' : 'hidden';
  }, [input]);

  const handleSend = async () => {
    const trimmed = input.trim();
    if (!trimmed || isLoading || isStreaming) return;

    setInput('');
    setIsLoading(true);

    try {
      await sendMessage(trimmed);
    } finally {
      setIsLoading(false);
    }
  };

  const handleKeyDown = (e: KeyboardEvent<HTMLTextAreaElement>) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      handleSend();
    }
  };

  const isDisabled = isLoading || isStreaming;

  return (
    <div className="flex justify-center px-[20px] pb-[24px]">
      {/* Outer pill */}
      <div
        className="
          flex
          items-center
          w-[439px]
          min-h-[60px]
          rounded-[100px]
          bg-[rgba(250,250,250,1)]
          border
          border-[rgba(217,217,217,0.2)]
          ps-[16px]
          pe-[24px]
          py-[var(--sds-size-space-300)]
        "
      >
        {/* Input */}
        <textarea
          ref={textareaRef}
          value={input}
          onChange={(e) => setInput(e.target.value)}
          onKeyDown={handleKeyDown}
          placeholder="Say something to Zeme"
          disabled={isDisabled}
          rows={1}
          style={{ scrollbarWidth: 'none', msOverflowStyle: 'none' }}
          className="
           flex-1 
           my-1
           mt-2
           py-1
           pe-0
           ps-1
           ms-2
           block
           bg-transparent
            font-geist 
            text-[#171717] 
            font-medium 
            text-[14px]
             placeholder:text-gray-700
              outline-none 
            border-none 
            ring-0 
            focus:outline-none
             focus:ring-0
             focus:border-none
             leading-[20px]
             resize-none
             overflow-y-hidden
             hide-scrollbar
             disabled:opacity-50

          "
        />

        {/* Send button */}
        <button
          type="button"
          onClick={handleSend}
          disabled={isDisabled || !input.trim()}
          className="
            ml-3
            flex
            h-9
            w-9
            items-center
            justify-center
            rounded-full
            text-sm font-medium text-[rgba(23,23,23,1)]
            hover:text-gray-700
            transition
            opacity-50
            disabled:opacity-30
            disabled:cursor-not-allowed
          "
        >
          <UpArrow />
        </button>
      </div>
    </div>
  );
}
